<template>
  <div class="processes">
    <p class="processes_title mb-7">{{ mess["index_title_by_process"] }}</p>
    <div class="processes_list">
      <a
        v-for="(item, i) in items"
        :key="i"
        :href="item.link"
        class="processes_card"
      >
        <p class="processes_card-title">{{ item.title }}</p>
        <div class="processes_card-img-wrap">
          <img :src="item.image" :alt="item.title" />
        </div>
        <p class="processes_card-arrow">
          <svg
            width="80"
            height="80"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="50" cy="50" r="49.5" stroke="black" />
            <path d="M34 50H65M65 50L59 44M65 50L59 56" stroke="black" />
          </svg>
        </p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessesMenu",
  props: {
    items: {
      type: [Array, null],
      default: () => []
    }
  }
};
</script>

<style lang="scss">
@import "ProcessesMenu";
</style>
